export default "__VITE_ASSET__Diwq5YUW__"